import '@ant-design/v5-patch-for-react-19';
import { useState, useEffect } from "react";
import { Modal, Form, Card, Row, Col, Input, Select, DatePicker } from "antd";

import { carregaListaMunicipios, carregaListaNaturezasJuridicasIbge, carregaListaPaises, carregaListaUF } from "../services";
import { maskCep, maskCnpj, maskNumeroProcesso, maskTelefone } from "../../../utils/maskFunctions";
import { color } from "../../../utils/utilsFunctions";

import type { IPessoaJuridica, ISelectList } from "../../../components/Interfaces";

import dayjs from "dayjs";

interface IProps {
  pessoaJuridicaEfpc: IPessoaJuridica | undefined;
  modalPessoaJuridicaSucessoAberto: boolean;
  setModalPessoaJuridicaSucessoAberto: React.Dispatch<React.SetStateAction<boolean>>;
}

const ModalPessoaJuridica = ({ pessoaJuridicaEfpc, setModalPessoaJuridicaSucessoAberto, modalPessoaJuridicaSucessoAberto }: IProps) => {

  const [form] = Form.useForm();

  const [listaNaturezasJuridicas, setListaNaturezasJuridicas] = useState<ISelectList[]>([]);
  const [listaPaises, setListaPaises] = useState<ISelectList[]>([]);
  const [listaUf, setListaUf] = useState<ISelectList[]>([]);
  const [listaMunicipios, setListaMunicipios] = useState<ISelectList[]>([]);
  const [codPais, setCodPais] = useState(76); // BRASIL
  const [codNaturezaJuridica, setCodNaturezaJuridica] = useState(0);

  useEffect(() => {
    const carregaDadosIniciais = async () => {
      if (listaPaises && listaPaises.length === 0) carregaListaPaisesOpcoes();
      if (listaNaturezasJuridicas && listaNaturezasJuridicas.length === 0) carregaListaNaturezasJuridicasOpcoes();
      if (listaUf && listaUf.length === 0) carregaListaUFOpcoes();
    }
    carregaDadosIniciais();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (pessoaJuridicaEfpc)
      setDadosPessoaJuridicaFull(pessoaJuridicaEfpc);
  }, [pessoaJuridicaEfpc]); // eslint-disable-line react-hooks/exhaustive-deps  

  useEffect(() => {
    if (listaNaturezasJuridicas && listaNaturezasJuridicas.length > 0) {
      form.setFieldsValue({
        nmNaturezaJuridica: listaNaturezasJuridicas.find(x => x.value === codNaturezaJuridica),
      });
    }
  }, [listaNaturezasJuridicas]); // eslint-disable-line react-hooks/exhaustive-deps

  function setDadosPessoaJuridicaFull(pj: IPessoaJuridica) {
    setCodNaturezaJuridica(pj.naturezaJuridica);
    setCodPais(pj.pais);

    form.setFieldsValue({
      cnpjNumero: pj.tipoIdentificador === 1 ? maskCnpj(pj.numero) : undefined,
      numeroIdentificacaoFiscal: pj.tipoIdentificador === 2 ? pj.numero : undefined,
      numeroProcesso: pj.numeroProcesso ? maskNumeroProcesso(pj.numeroProcesso) : undefined,
      nomeFantasia: pj.nomeFantasia,
      razaoSocial: pj.razaoSocial,

      atividadeEconomica: pj.numeroCnae,

      situacaoCadastral: pj.situacaoCadastral,
      dataSituacaoCadastral: pj.dataSituacaoCadastral ? dayjs(pj.dataSituacaoCadastral) : undefined,

      cep: maskCep(pj.cep),
      logradouro: pj.logradouro,
      numeroEndereco: pj.numeroEndereco,
      nmPais: pj.nomePais ? pj.nomePais.toUpperCase() : "",
      siglaUf: pj.siglaUf,
      nomeCidade: pj.nomeCidade,
      bairro: pj.bairro,
      complemento: pj.complemento,
      telefone1: pj.telefone1 ? maskTelefone(pj.telefone1) : undefined,
      telefone2: pj.telefone2 ? maskTelefone(pj.telefone2) : undefined,
      email: pj.email,
      emailInstitucional: pj.emailInstitucional,
      site: pj.site,
      observacao: pj.observacao,
    });
  }

  const carregaListaNaturezasJuridicasOpcoes = async () => {
    let listaLocal: any = [];
    //    await carregaListaNaturezasJuridicas().then((response) => {
    await carregaListaNaturezasJuridicasIbge().then((response) => {
      response.data.forEach((p: any) => {
        // listaLocal.push({ value: p.codigo, label: p.descricao });
        listaLocal.push({ value: p.codNaturezaJuridica, label: (p.codNaturezaJuridica + " - " + p.descNaturezaJuridica.toUpperCase()) });
      })
    });
    setListaNaturezasJuridicas(listaLocal);
  }

  const carregaListaPaisesOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaPaises().then((response) => {
      response.data.forEach((p: any) => {
        // if (p.id['M49'] !== 76) {  // BRASIL
        //   listaLocal.push({ value: p.id['M49'], label: p.nome });
        // }
        listaLocal.push({ value: p.id['M49'], label: p.nome.toUpperCase() });
      });
    });

    const sortedList = [...listaLocal].sort((a, b) =>
      a.label.localeCompare(b.label)
    );

    // Coloca o Brasil no tipo da lista
    const brasilItem = sortedList.find(x => x.value === 76);
    const newList = [brasilItem, ...sortedList.filter(x => x.value !== 76)];
    setListaPaises(newList);
  }

  const carregaListaUFOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaUF().then((response) => {
      response.data.forEach((p: any) => {
        listaLocal.push({ value: p.id, label: p.sigla })
      });
    });
    setListaUf(listaLocal);
  }

  const handleNaturezaJuridica = async (naturezaJuridica: any) => {

    form.setFieldsValue({
      nmNaturezaJuridica: naturezaJuridica.label,
    });

    setCodNaturezaJuridica(naturezaJuridica.value);
  };

  const handlePais = async (pais: any) => {
    form.setFieldsValue({
      nmPais: pais.label,
    });

    setCodPais(pais.value);

    if (pais.value !== 76) { // BRASIL
      form.setFieldsValue({
        siglaUf: undefined,
        nomeCidade: undefined,
      });
    }
  };

  const handleModalOk = () => {
    setModalPessoaJuridicaSucessoAberto(false);
  };

  return (
    <Modal title="Pessoa Jurídica"
      width={"80%"}
      closable={false}
      open={modalPessoaJuridicaSucessoAberto} onOk={handleModalOk}
      cancelButtonProps={{ disabled: true }}>

      <Form layout='vertical' style={{ padding: 24 }} scrollToFirstError form={form} >
        <div className="main-content pl-sm-3 mt-4">
          <h1>Detalhar Pessoa Jurídica</h1>
        </div>

        <Card>
          <div className="main-content pl-sm-3 mt-4">
            <h2>Informações Básicas</h2>
          </div>

          <Row>
            <Col xs={24} xl={6}>
              <Form.Item
                label='CNPJ'
                name='cnpjNumero'
              >
                <Input maxLength={18}
                  disabled
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={7}>
              <Form.Item
                label='Número de Identificação Fiscal (NIF)'
                name='numeroIdentificacaoFiscal'
              >
                <Input
                  maxLength={21}
                  disabled
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={6}>
              <Form.Item
                label='Número do Processo'
                name='numeroProcesso'
              >
                <Input
                  disabled
                  maxLength={21}
                />
              </Form.Item>
            </Col>

          </Row>
          <Row>
            <Col xs={24} xl={15}>
              <Form.Item
                label='Nome Empresarial'
                name='razaoSocial'
              >
                <Input maxLength={100}
                  disabled
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={7}>
              <Form.Item
                label='Nome Fantasia'
                name='nomeFantasia'
              >
                <Input maxLength={100}
                  disabled
                  style={{ backgroundColor: color.nomeFantasiaColor }}
                />
              </Form.Item>
            </Col>
          </Row>

          <div className="main-content pl-sm-3 mt-4">
            <h2>Informações da Receita Federal</h2>
          </div>

          <Row>
            <Col xs={24} xl={12}>
              <Form.Item
                label='Natureza Jurídica'
                name='nmNaturezaJuridica'
              >
                <Select
                  disabled
                  showSearch filterOption optionFilterProp='children'
                  placeholder='SELECIONE UMA NATUREZA JURÍDICA'
                  options={listaNaturezasJuridicas}
                  onChange={(_, index) => {
                    handleNaturezaJuridica(index);
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={12}>
              <Form.Item
                label='Atividade Econômica Principal'
                name='atividadeEconomica'>
                <Input maxLength={100}
                  disabled
                  style={{ backgroundColor: color.nomeFantasiaColor }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} xl={6}>
              <Form.Item
                label='Data de Abertura'
                name='dataAbertura' >
                <DatePicker
                  disabled
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  placeholder="Selecionar Data"
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={6}>
              <Form.Item
                label='Situação Cadastral'
                name='situacaoCadastral'>
                <Input disabled maxLength={20} />
              </Form.Item>
            </Col>

            <Col xs={24} xl={6}>
              <Form.Item
                label='Data Situação Cadastral'
                name='dataSituacaoCadastral' >
                <Input disabled maxLength={20} />
              </Form.Item>
            </Col>
            <Col xs={24} xl={6}>
              <Form.Item
                label='Motivo da Situação Cadastral'
                name='motivoSituacao'>
                <Input disabled maxLength={20} />
              </Form.Item>
            </Col>
          </Row>

          <div className="main-content pl-sm-3 mt-4">
            <h2>Endereço</h2>
          </div>

          <Row>
            <Col xs={24} xl={5}>
              <Form.Item
                label='CEP'
                name='cep'
              >

                <Input maxLength={10}
                  style={{ width: "100%", backgroundColor: color.cepColor }}
                  disabled
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={11}>
              <Form.Item
                label='Logradouro'
                name='logradouro'
              >
                <Input maxLength={100}
                  disabled
                  style={{ backgroundColor: color.enderecoColor }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={5}>
              <Form.Item
                label='Número'
                name='numeroEndereco'
              >
                <Input
                  maxLength={10}
                  disabled
                  style={{ backgroundColor: color.numeroColor }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} xl={5}>
              <Form.Item
                label='País'
                name='nmPais'
              >
                <Select showSearch filterOption optionFilterProp='children'
                  placeholder='País'
                  disabled
                  options={listaPaises}
                  onChange={(_, index) => {
                    handlePais(index);
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={4}>
              <Form.Item
                label='UF'
                name='siglaUf'
              >
                {codPais === 76 ? (
                  <Select showSearch filterOption optionFilterProp='children' placeholder='Estados'
                    className={color.ufColor === "#ffdada" ? "input" : ""}
                    disabled
                    onChange={(e) => {
                      carregaListaMunicipios(e.value).then((response) => {
                        setListaMunicipios(response.data);
                      });
                    }
                    }
                    options={listaUf}
                  />
                ) : (
                  <Input
                    maxLength={100}
                    disabled
                  />
                )}
              </Form.Item>
            </Col>

            <Col xs={24} xl={7}>
              <Form.Item
                label='Município'
                name='nomeCidade'
              >
                {codPais === 76 ? (
                  <Select showSearch filterOption optionFilterProp='children' placeholder='Município'
                    className={
                      color.municipioColor === "#ffdada" ? "input" : ""
                    }
                    disabled
                    options={listaMunicipios}
                  />
                ) : (
                  <Input
                    maxLength={100}
                    disabled
                  />
                )}
              </Form.Item>
            </Col>

            <Col xs={24} xl={8}>
              <Form.Item
                label='Bairro'
                name='bairro'
              >
                <Input maxLength={60}
                  disabled
                  style={{ backgroundColor: color.bairroColor }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} xl={12}>
              <Form.Item
                label='Complemento'
                name='complemento'>
                <Input
                  maxLength={30}
                  disabled
                  style={{ backgroundColor: color.complementoColor }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={6}>
              <Form.Item
                label='Telefone 1'
                name='telefone1'
              >
                <Input maxLength={15}
                  onChange={(e) =>
                    form.setFieldsValue({
                      telefone1: maskTelefone(e.target.value),
                    })
                  }
                  style={{
                    width: "100%",
                    backgroundColor: color.telefone1Color,
                  }}
                  disabled
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={6}>
              <Form.Item
                label='Telefone 2'
                name='telefone2'>
                <Input maxLength={15}
                  style={{ width: "100%" }}
                  disabled
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} xl={8}>
              <Form.Item
                label='E-mail'
                name='email'
              >
                <Input
                  maxLength={100}
                  disabled
                  style={{
                    textTransform: "lowercase",
                    backgroundColor: color.emailColor,
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={8}>
              <Form.Item
                label='E-mail Comunicação PREVIC'
                name='emailInstitucional'

              >
                <Input
                  maxLength={100}
                  disabled
                  style={{ textTransform: "lowercase" }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={8}>
              <Form.Item
                label='Site'
                name='site'>
                <Input className='lowercase'
                  maxLength={100}
                  disabled
                  addonBefore={(
                    <Select
                      disabled
                      defaultValue='https://'
                      className='select-before lowercase' options={[
                        { value: 'http://', label: 'http://' },
                        { value: 'https://', label: 'https://' }
                      ]}
                    >
                    </Select>
                  )}
                />
              </Form.Item>
            </Col>
          </Row>

        </Card>

      </Form>
    </Modal>

  );
};

export default ModalPessoaJuridica;

